/** Small helpers shared by every screen. */
export const EN = '–', DOT = '·', ARROW = '→', DEG = '°', NOKEY = '—';

export const $ = <T extends HTMLElement = HTMLElement>(s: string, r: ParentNode = document): T => {
  const el = r.querySelector<T>(s);
  if (!el) throw new Error('missing element ' + s);
  return el;
};
export const $maybe = <T extends HTMLElement = HTMLElement>(s: string, r: ParentNode = document): T | null => r.querySelector<T>(s);
export const $$ = <T extends HTMLElement = HTMLElement>(s: string, r: ParentNode = document): T[] => Array.from(r.querySelectorAll<T>(s));
export const esc = (s: unknown): string => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
export const pad4 = (n: number | string): string => String(n).padStart(4, '0');
export const plural = (n: number, one: string, many?: string): string => (n === 1 ? one : many ?? one + 's');
export const money = (cents: number): string => '$' + (cents / 100).toFixed(2);
export const num = (n: number): string => n.toLocaleString('en-US');
export const normRot = (d: number): number => (((Math.round(d / 90) * 90) % 360) + 360) % 360;
export const spaced = (k: string): string => (k === NOKEY || !k ? '(none)' : k.split('').join(' '));
export const slug = (s: string): string => s.replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '');
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso.length === 10 ? iso + 'T00:00:00Z' : iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', ...(iso.length === 10 ? { timeZone: 'UTC' } : {}) });
}
export const fmtDateTime = (iso: string): string => new Date(iso).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
export const timeLabel = (iso: string): string => new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
export const kb = (n: number): string => (n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB');

export function toast(msg: string, kind?: 'err'): void {
  const t = document.createElement('div');
  t.className = 'toast' + (kind ? ' ' + kind : '');
  t.textContent = msg;
  const box = $('#toasts');
  while (box.children.length >= 3) box.firstElementChild!.remove();
  box.appendChild(t);
  setTimeout(() => t.classList.add('out'), kind ? 6500 : 4200);
  setTimeout(() => t.remove(), kind ? 7000 : 4700);
}

export function setErr(el: HTMLElement, msg?: string | null): false {
  el.textContent = msg || '';
  el.hidden = !msg;
  return false;
}

export function throttle(fn: () => void, ms: number): () => void {
  let last = 0, timer: ReturnType<typeof setTimeout> | undefined;
  return () => {
    const now = Date.now();
    clearTimeout(timer);
    if (now - last >= ms) { last = now; fn(); } else timer = setTimeout(() => { last = Date.now(); fn(); }, ms);
  };
}

export function openDialog(d: HTMLDialogElement): void { if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', ''); }
export function closeDialog(d: HTMLDialogElement): void { if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); }

/** Save a blob as a file the ordinary way. */
export function saveBlob(blob: Blob, filename: string): void {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.hidden = true;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 5000);
}
